/** 任务列表展示：与视频生成结果字段一致 */

export const VIDEO_CONCEPT_PRESET_LABELS = {
  natural: '自然动态',
  casual: '休闲走动',
  magazine: '杂志写真',
  closeup: '特写展示',
  catwalk: '随心走秀',
};

/** Worker agentVideoPhase → 用户可读文案 */
export const VIDEO_AGENT_PHASE_LABELS = {
  QUEUE_WAIT: '排队中',
  PENDING: '等待上游',
  RUNNING: '生成中',
  SUCCEEDED: '已完成',
  FAILED: '失败',
  CANCELED: '已取消',
  CANCELLED: '已取消',
  TIMEOUT: '超时',
  UNKNOWN: '未知',
};

export function formatAgentVideoPhaseLabel(phase) {
  const key = String(phase || '').trim().toUpperCase();
  if (!key) return '';
  return VIDEO_AGENT_PHASE_LABELS[key] || key;
}
